<template>
  <main class="support-email-page safe-page">
    <AppNavBar :title="t('mine.supportEmail')" />

    <section class="support-card">
      <div class="support-row">
        <app-image src="@/assets/images/mail_withbg_icon.png" alt="" class="support-row__icon" />
        <div class="support-row__content">
          <div class="support-row__title">{{ t('mine.serviceMailbox') }}</div>
          <div class="support-email" @click="copyEmail">
            <span>{{ supportEmail }}</span>
            <app-image src="@/assets/images/copy_icon_gray.png" alt="" />
          </div>
        </div>
      </div>

      <div class="support-divider" />

      <div class="support-row">
        <app-image src="@/assets/images/support_icon.png" alt="" class="support-row__icon" />
        <div class="support-row__content">
          <div class="support-row__title">{{ t('mine.serviceHours') }}</div>
          <div class="support-row__value">{{ t('mine.weekdayHours') }}</div>
        </div>
      </div>

      <div class="support-divider" />

      <p class="support-tip">{{ t('mine.supportReplyTip') }}</p>
      <p class="support-tip">{{ t('mine.supportThanks') }}</p>
    </section>
  </main>
</template>

<script setup>
import { showFailToast, showToast } from 'vant';
import { showPassedToast } from '@/utils/toast';
import { useI18n } from 'vue-i18n';
import { copyToClipboard } from '@/utils/clipboard';

const { t } = useI18n();
const supportEmail = 'cs@winpay.ai';

async function copyEmail() {
  const copied = await copyToClipboard(supportEmail);
  if (copied) {
    showPassedToast(t('wallet.copySuccess'));
    return;
  }
  showFailToast(t('wallet.copyFailed'));
}
</script>

<style scoped lang="scss">
.support-email-page {
  min-height: var(--app-viewport-height);
  padding: 0 14px 24px;
  background: #f5f5f5;
}

.support-card {
  margin-top: 14px;
  padding: 20px 16px;
  border-radius: 16px;
  background: #ffffff;
}

.support-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.support-row__icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  object-fit: contain;
}

.support-row__content {
  min-width: 0;
  flex: 1;
}

.support-row__title {
  color: #000000;
  font-size: 16px;
  line-height: 22px;
}

.support-row__value {
  margin-top: 7px;
  color: #2667ff;
  font-size: 14px;
  line-height: 20px;
}

.support-email {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 7px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2667ff;
  font-size: 14px;
  line-height: 20px;

  .app-image {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }
}

.support-divider {
  height: 1px;
  margin: 16px 0;
  background: #f4f5f6;
}

.support-tip {
  margin: 0;
  color: #666666;
  font-size: 12px;
  line-height: 18px;

  + .support-tip {
    margin-top: 7px;
  }
}
</style>
